module.exports = __webpack_public_path__ + "img/CS-Hybrid_Ad-TrapRoller_1.cc90cbd0.jpg";